import { useIntl } from "react-intl";
import app1 from "../assets/images/app_1.png";
import app2 from "../assets/images/app_2.png";
import googlePlayBadge from "../assets/images/google-play-badge.png";
import appStoreBadge from "../assets/images/app-store-badge.png";

const apps = [
  {
    id: "rider",
    image: app1,
    titleId: "home.downloads.rider",
    hrefQr: "https://lyft.sng.link/Adnq0/o6zi4?_dl=lyft%3A%2F%2F&_smtype=3",
    hrefGoogle: "https://lyft.sng.link/Adnq0/o6zi4?_dl=lyft%3A%2F%2F&_smtype=3",
    hrefApple: "https://lyft.sng.link/Adnq0/o6zi4?_dl=lyft%3A%2F%2F&_smtype=3",
  },
  {
    id: "driver",
    image: app2,
    titleId: "home.downloads.driver",
    hrefQr: "https://lyftdriver.sng.link/Alqxq/8lflu?_dl=lyftdriver%3A%2F%2Fhome&_smtype=3",
    hrefGoogle: "https://lyftdriver.sng.link/Alqxq/acl6?_dl=lyftdriver%3A%2F%2Fhome&_smtype=3",
    hrefApple: "https://lyftdriver.sng.link/Alqxq/acl6?_dl=lyftdriver%3A%2F%2Fhome&_smtype=3",
  },
  {
    id: "mappers",
    image: app1,
    titleId: "home.downloads.mappers",
    hrefQr: "#",
    hrefGoogle: "#",
    hrefApple: "#",
  },
  {
    id: "eats",
    image: app2,
    titleId: "home.downloads.eats",
    hrefQr: "#",
    hrefGoogle: "#",
    hrefApple: "#",
  },
  {
    id: "travelHub",
    image: app1,
    titleId: "home.downloads.travelHub",
    hrefQr: "#",
    hrefGoogle: "#",
    hrefApple: "#",
  },
  {
    id: "program",
    image: app2,
    titleId: "home.downloads.program",
    hrefQr: "#",
    hrefGoogle: "#",
    hrefApple: "#",
  },
];

export default function DownloadAppsSection() {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  return (
    <section className="download-apps-section">
      <style>{`
        .download-apps-section {
          background: #f4f4f9;
          padding: 56px 20px;
        }

        .download-apps-inner {
          max-width: 1400px;
          margin: 0 auto;
        }

        .download-apps-title {
          margin: 0 0 28px;
          text-align: center;
          font-size: clamp(1.4rem, 2.4vw, 1.8rem);
          font-weight: 800;
          color: #0f1b3d;
        }

        .download-apps-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
        }

        @media (max-width: 639px) {
          .download-apps-grid {
            grid-template-columns: 1fr;
          }
        }

        .download-apps-card {
          display: flex;
          align-items: center;
          gap: 24px;
          width: 100%;
          box-sizing: border-box;
          background: #fff;
          border-radius: 16px;
          padding: 24px;
          box-shadow: 0 4px 20px rgba(10, 37, 64, 0.08);
          overflow: hidden;
        }

        .download-apps-qr-img {
          width: 100px;
          height: 100px;
          min-width: 100px;
          display: block;
          border-radius: 8px;
        }

        .download-apps-content {
          display: flex;
          flex-direction: column;
          min-width: 0;
          flex: 1;
        }

        .download-apps-card-title,
        .download-apps-card-subtitle {
          margin: 0 0 6px;
          overflow-wrap: break-word;
          word-break: break-word;
        }

        .download-apps-card-title {
          color: #0c6f3f;
          font-size: 16px;
          font-weight: 700;
        }

        .download-apps-card-subtitle {
          font-size: 13px;
          color: #4b5563;
        }

        .download-apps-available-label {
          margin: 0 0 8px;
          font-size: 12px;
          color: #9ca3af;
        }

        .download-apps-badges {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .download-apps-badge-img {
          height: 36px;
          width: auto;
          display: block;
        }
      `}</style>

      <div className="download-apps-inner">
        <h2 className="download-apps-title">{t("home.downloads.title")}</h2>

        <div className="download-apps-grid">
          {apps.map((app) => (
            <div key={app.id} className="download-apps-card">
              <a href={app.hrefQr} className="download-apps-qr">
                <img src={app.image} alt={t(app.titleId)} className="download-apps-qr-img" />
              </a>

              <div className="download-apps-content">
                <h3 className="download-apps-card-title">{t(app.titleId)}</h3>
                <p className="download-apps-card-subtitle">{t("home.downloads.scan")}</p>
                <p className="download-apps-available-label">Disponible sur</p>

                <div className="download-apps-badges">
                  <a href={app.hrefGoogle}>
                    <img src={googlePlayBadge} alt="Disponible sur Google Play" className="download-apps-badge-img" />
                  </a>
                  <a href={app.hrefApple}>
                    <img src={appStoreBadge} alt="Télécharger sur l'App Store" className="download-apps-badge-img" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
